/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState
} from '@sg/api/base-api-lib';
import { BroadcastApiConfig } from '../api-config';

import { BroadcastApi } from '../models';

@Injectable()
export class BroadcastMessageApiClient extends BaseApiClient<BroadcastApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.broadcastApiConfig);
  }

  messageControllerSearchMessages(
    params: {
      body: BroadcastApi.MessageSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.MessageSearchResponse>;
  messageControllerSearchMessages(
    params: {
      body: BroadcastApi.MessageSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.MessageSearchResponse>>;
  messageControllerSearchMessages(
    params: {
      body: BroadcastApi.MessageSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.MessageSearchResponse>;
  messageControllerSearchMessages(
    params: {
      body: BroadcastApi.MessageSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.MessageSearchResponse>>;
  messageControllerSearchMessages(
    params: {
      body: BroadcastApi.MessageSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.MessageSearchResponse>>;
  messageControllerSearchMessages(
    params: {
      body: BroadcastApi.MessageSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.MessageSearchResponse>>;
  messageControllerSearchMessages(
    params: {
      body: BroadcastApi.MessageSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(
      ['', 'pageSize', params.pageSize],
      ['', 'pageNumber', params.pageNumber],
      ['', 'order', params.order],
      ['', 'orderBy', params.orderBy],
      ['', 'sortDirection', params.sortDirection]
    );

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<BroadcastApi.MessageSearchResponse>(
      `${this.basePath}/gateway/admin/broadcast/message/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  messageControllerGetMessageById(
    id: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Message>;
  messageControllerGetMessageById(
    id: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Message>>;
  messageControllerGetMessageById(
    id: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Message>;
  messageControllerGetMessageById(
    id: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Message>>;
  messageControllerGetMessageById(
    id: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Message>>;
  messageControllerGetMessageById(
    id: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Message>>;
  messageControllerGetMessageById(
    id: string,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', id]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<BroadcastApi.Message>(
      `${this.basePath}/gateway/admin/broadcast/message/${this.encodeURI(String(id))}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
